/**
 * /tenants/new — thin route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { CreateTenantPage } from "@/features/tenants/pages/create-tenant-page";

export const Route = createFileRoute("/_authed/tenants/new")({
  component: CreateTenantPage,
});
